import React from "react";
import { Helmet } from "react-helmet";
import { LazyLoadImage } from "react-lazy-load-image-component";
import MultiLingualContent from "../../../languages/MultiLingualContent";
import pamotit1 from "../../../assets/images/pamotit1.jpeg";
import BackButton from "../../backButton";

const Pamotit = () => {
  return (
    <div className="inner-section" id="pamotit">
      <Helmet>
        <title>פטרידע - הפטריה פמוטית</title>
        <meta
          name="description"
          content="הפטריה פמוטית - Phellorinia: תאור, זיהוי ותמונות"
        />
      </Helmet>
      <BackButton path="/#types-and-species" />
      <h2>
        <MultiLingualContent contentID="pamotit" />
      </h2>
      <>
        <div className="informationText">
          <p>
            <MultiLingualContent contentID="pamotitText1" />
          </p>
          <p>
            <MultiLingualContent contentID="pamotitText2" />
          </p>
          <p>
            <MultiLingualContent contentID="pamotitText3" />
          </p>
          <br />
        </div>
        <div className="informationImages">
          <div className="imgWrapper">
            <LazyLoadImage src={pamotit1} alt="פמוטית" />
            <p>
              <MultiLingualContent contentID="pamotitImg1" />
            </p>
          </div>
        </div>
      </>
    </div>
  );
};

export default Pamotit;
